export const sendDocuments = (files, type, subtype) => {
    if (!files) return null;
    const formData = new FormData();
    if (typeof files === 'object' && files.length) {
        files.forEach(f => formData.append('files[]', f));
    } else {
        formData.append('files[]', files);
    }
    formData.append('type', type);
    if (subtype) {
        formData.append('subtype', subtype);
    }
    return formData;
};
